module.exports = __webpack_public_path__ + "img/forbidden_city1.c8f0be74.jpg";